var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_13192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9286 64C36.3051 64 39.8571 60.416 39.8571 56V48H31.9286C27.552 48 24 51.584 24 56C24 60.416 27.552 64 31.9286 64Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 40C24 35.584 27.552 32 31.9286 32H39.8571V48H31.9286C27.552 48 24 44.416 24 40Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 24C24 19.584 27.552 16 31.9286 16H39.8571V32H31.9286C27.552 32 24 28.416 24 24Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8571 16H47.7857C52.1623 16 55.7143 19.584 55.7143 24C55.7143 28.416 52.1623 32 47.7857 32H39.8571V16Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7143 40C55.7143 44.416 52.1623 48 47.7857 48C43.4091 48 39.8571 44.416 39.8571 40C39.8571 35.584 43.4091 32 47.7857 32C52.1623 32 55.7143 35.584 55.7143 40Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_13192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 48,
    fill: "white",
    transform: "translate(24 16)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.87f1e8dad4c924de1aa399cb9ccb81ca.svg";
export { ForwardRef as ReactComponent };